"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TabContainer = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable react/no-children-prop */


var TabContainer = function TabContainer(_ref) {
  var children = _ref.children,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'div' : _ref$component;
  return _react.default.createElement(component, {
    style: {
      display: 'flex'
    },
    children: children
  });
};

exports.TabContainer = TabContainer;
var _default = TabContainer;
exports.default = _default;